module.exports = __webpack_public_path__ + "static/media/image-banner-2.9de1ff1f.svg";